import { NgModule } from '@angular/core';
import { NwCalendarComponent } from './nw-calendar.component';
import {CommonModule} from '@angular/common';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';


@NgModule({
  declarations: [NwCalendarComponent],
  imports: [
    CommonModule,
    FontAwesomeModule
  ],
  exports: [NwCalendarComponent]
})
export class NwCalendarModule { }
